const initialState = {
    loading: false,
    data: [],
    pageSize: 10,
    pageIndex: 1,

};

export default function doctorAndTime(state = initialState, action = {}) {
    switch (action.type) {
        case 1:
            return {
                ...state
            }
        default:
            return state;
    }
}